import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Table from 'material-ui/Table'
import { TableBody } from 'material-ui/Table'
import { TableCell } from 'material-ui/Table'
import { TableHead } from 'material-ui/Table'
import { TableRow } from 'material-ui/Table'
import Icon from 'material-ui/Icon'
import { withStyles } from 'material-ui/styles'
import BidirectionalFiber from './types/bidirectional'
import UnidirectionalFiber from './types/unidirectional'
import LoopbackFiber from './types/loopback'
import BidirectionalLoopbackFiber from './types/bidirectionalloopback'
import styles from './styles'
import {
  metersToFeet
} from '../../../../../common/utils'
class Fiber extends React.Component {
  constructor(props) {
    super(props)
  }

  lengthUnitConverter = (length) => {
    const { chartMeasurementUnit } = this.props
    if (chartMeasurementUnit === 'feet') {
      return metersToFeet(length)
    }
    return length
  }
  render() {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit
    } = this.props

    if (!results.data.fibertest.length) {
      return null
    }
    const {
      filetype,
      standard
    } = results.data
    const measurementUnit = chartMeasurementUnit === 'feet' ? '(ft)' : '(m)'
    const insertionLossData = results.data.fibertest.find(x => x.subtesttypeid === 'ATTEN')
    let fiberLengthData = results.data.fibertest.find(x => x.subtesttypeid === 'Length')
    if(!fiberLengthData) {
      fiberLengthData =  results.data.fibertest.find(x => x.subtesttypeid === 'LengthHigh')
    }

    const { isbi, isloop } = results.data
    const testresults = []
    let handset1 = []
    let handset2 = []

    if (isbi) {
      handset1 = insertionLossData.fiberdata.filter(x => 1 === parseInt(x.fibernumber, 10))
      handset2 = insertionLossData.fiberdata.filter(x => 2 === parseInt(x.fibernumber, 10))
      testresults.push(handset1)
      testresults.push(handset2)
    } else {
      handset1 = insertionLossData.fiberdata.filter(x => 1 === parseInt(x.handset, 10))
      handset2 = insertionLossData.fiberdata.filter(x => 2 === parseInt(x.handset, 10))
      testresults.push([...handset1, ...handset2])
    }
    // const FiberView = isbi ? BidirectionalFiber : isloop ? LoopbackFiber : UnidirectionalFiber

    const FiberView = isbi && isloop ? BidirectionalLoopbackFiber :
      isbi && !isloop ? BidirectionalFiber :
        isloop && !isbi ? LoopbackFiber :
          UnidirectionalFiber

    const lengthData = (fiberLengthData && fiberLengthData.fiberlengthdata) ? fiberLengthData.fiberlengthdata : {}
    if (lengthData.refractiveindex == null) {
      lengthData.refractiveindex = 1.493
    }

    return (
      <FiberView
        testresults={testresults}
        fiberLengthData={lengthData}
        measurementUnit={measurementUnit}
        translate={translate}
        chartMeasurementUnit={chartMeasurementUnit}
        isbi={isbi}
        isloop={isloop}
        standard={standard}
        configuration={filetype}
        results={results}
      />
    )
  }
}

export default withStyles(styles)(Fiber)

